// 主题色
export const $primary = '#409bff'
export const $primary_light = '#69b2ff'

export const $error = '#f27b7b'
export const $error_light = '#fc9c9c'

export const $success = '#47cfcd'
export const $success_light = '#6ddced'

export const $warning = '#ffba24'
export const $warning_light = '#fffe87'
export const $warning2 = '#ff8a42'
export const $warning2_light = '#ffc02e'

// 文字颜色
export const $black_text = '#606060'
export const $gray_text = '#b2b2b3'



// WEBPACK FOOTER //
// ./src/utils/theme/colors.js